import { render, staticRenderFns } from "./EditBanner.vue?vue&type=template&id=c0efaeb8&scoped=true&"
import script from "./EditBanner.vue?vue&type=script&lang=js&"
export * from "./EditBanner.vue?vue&type=script&lang=js&"
import style0 from "./EditBanner.vue?vue&type=style&index=0&id=c0efaeb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0efaeb8",
  null
  
)

export default component.exports